import { render, staticRenderFns } from "./SurveyLanguageSelector.vue?vue&type=template&id=01e1fdc6&scoped=true"
import script from "./SurveyLanguageSelector.vue?vue&type=script&lang=js"
export * from "./SurveyLanguageSelector.vue?vue&type=script&lang=js"
import style0 from "./SurveyLanguageSelector.vue?vue&type=style&index=0&id=01e1fdc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e1fdc6",
  null
  
)

export default component.exports